import { render, staticRenderFns } from "./CustomersItem.vue?vue&type=template&id=443d17c2&lang=pug&"
import script from "./CustomersItem.vue?vue&type=script&lang=js&"
export * from "./CustomersItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports